import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { Container, Row, Col, Form } from "react-bootstrap";

import { ButtonStandard, LoadingSpinner } from "../../components";
import "./PreSchedulingReport.scss"
import messages from "../../assets/i18n";
import { COMPANIES } from '../../utils/constants';
import havePermissionTo from '../../utils/havePermission';
import { downloadFile } from '../../utils/utilFile';
import { PRE_SCHEDULING_REPORT_HEADERS } from '../../utils/constants';

function PreSchedulingReport(props) {

    const dispatch = useDispatch();

    const lang = useSelector(state => state.language.name);
    const permissions = useSelector(state => state.authorization.permissions);
    const messagePage = messages[lang].preSchedulingReport;

    const isLoadingPreSchedulingReport = useSelector(state => state.preScheduling.isLoadingPreSchedulingReport);
    const csvReportData = useSelector(state => state.preScheduling.csvReportData);

    const [reportFilters, setReportFilters] = useState({
        nomeFornecedor: '',
        cnpjFornecedor: '',
        nomeCd: '',
        nomeEmpresa: '',
        ativo: ''
    });

    const [checkPermission, setCheckPermission] = useState(true);

    const setFilters = (newFilters) => {
        setReportFilters(newFilters)
    };

    const companyOptions = [
        { id: '', message: "Todos" },
        { id: COMPANIES.RENNER.NAME, message: COMPANIES.RENNER.NAME },
        { id: COMPANIES.CAMICADO.NAME, message: COMPANIES.CAMICADO.NAME },
        { id: COMPANIES.YOUCOM.NAME, message: COMPANIES.YOUCOM.NAME },
    ];

    const activeOptions = [
        { id: '', message: "Todos" },
        { id: "true", message: messages[lang].yes },
        { id: "false", message: messages[lang].no },
    ];

    useEffect(() => {
        if (havePermissionTo("pre-scheduling-report-change-company", permissions)) {
            setCheckPermission(false)
        } else {
            setCheckPermission(true)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (csvReportData && csvReportData.length > 0) {
            let reportArray = [];
            let fileHeaders = []

            for (let i = 0; i < csvReportData.length; i++) {
                let newItem = []
                for (let j = 0; j < PRE_SCHEDULING_REPORT_HEADERS.length; j++) {
                    if (i === 0) {
                        fileHeaders.push(messages[lang].csvPreSchedulingReport[PRE_SCHEDULING_REPORT_HEADERS[j]])
                    }

                    let newValue
                    newValue = csvReportData[i][PRE_SCHEDULING_REPORT_HEADERS[j]] ? csvReportData[i][PRE_SCHEDULING_REPORT_HEADERS[j]] : ''

                    newItem.push(newValue)
                }
                reportArray.push(newItem)
            }

            const filename = messagePage.titleCsv + `.csv`;

            const textCsv = mountCsvText([fileHeaders, ...reportArray]);
            downloadFile(textCsv, filename);
            dispatch({ type: "SET_CSV_PRE_SCHEDULING_REPORT", payload: [] });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [csvReportData])

    const mountCsvText = (arrayToText) => {
        const separator = ';';
        return arrayToText.reduce((csvText, currentRow) => {

            const rowText = currentRow.reduce((csvRow, currentColumn) => {
                return csvRow ? `${csvRow}${separator}${currentColumn}` : currentColumn
            }, '');

            return csvText ? `${csvText}\n${rowText}` : rowText
        }, '');
    }

    const getReport = () => {
        dispatch({
            type: 'GET_PRE_SCHEDULING_REPORT',
            payload: {
                permissions: permissions,
                filters: reportFilters,
                checkPermission: checkPermission
            }
        })
    }

    const getCSVReport = () => {
        dispatch({
            type: 'GET_CSV_PRE_SCHEDULING_REPORT',
            payload: {
                permissions: permissions,
                filters: reportFilters,
                checkPermission: checkPermission
            }
        })
    }

    return (
        <div className="pre-scheduling-report-page">
            <Container className="pt-3 justify-content-start">
                <Row className="justify-content-between">
                    <Col className="d-flex align-items-center justify-content-start">
                        <span className="text-3 font-weight-bold header-main pl-2">{messagePage.title}</span>
                    </Col>
                </Row>
                <Form className="px-3">
                    <Row>

                        <Form.Group as={Col} className="mt-1">
                            <Form.Label className="text-2">{messagePage.providerName}</Form.Label>
                            <Form.Control
                                className="text-2 border-radius-full"
                                placeholder={messagePage.providerName}
                                type="text"
                                defaultValue={''}
                                onChange={event => setFilters(
                                    { ...reportFilters, nomeFornecedor: event.target.value },
                                )}
                            />
                        </Form.Group>

                        <Form.Group as={Col} className="mt-1">
                            <Form.Label className="text-2">{messagePage.providerDoc}</Form.Label>
                            <Form.Control
                                className="text-2 border-radius-full"
                                placeholder={messagePage.providerDoc}
                                type="text"
                                defaultValue={''}
                                onChange={event => setFilters(
                                    { ...reportFilters, cnpjFornecedor: event.target.value },
                                )}
                            />
                        </Form.Group>

                        <Form.Group as={Col} className="mt-1">
                            <Form.Label className="text-2">{messagePage.company}</Form.Label>
                            <Form.Control
                                as="select"
                                className="text-2 border-radius-full"
                                type="text"
                                value={reportFilters.nomeEmpresa || ''}
                                disabled={false}
                                onChange={event => setFilters(
                                    { ...reportFilters, nomeEmpresa: event.target.value },
                                )}
                            >
                                {
                                    companyOptions.map(value => (
                                        <option key={value.message} value={value.id}>{value.message}</option>
                                    ))
                                }
                            </Form.Control>
                        </Form.Group>


                        <Form.Group as={Col} className="mt-1">
                            <Form.Label className="text-2">{messagePage.cd}</Form.Label>
                            <Form.Control
                                className="text-2 border-radius-full"
                                placeholder={messagePage.cd}
                                defaultValue={''}
                                onChange={event => setFilters(
                                    { ...reportFilters, nomeCd: event.target.value },
                                )}
                            />
                        </Form.Group>

                        <Form.Group as={Col} className="mt-1">
                            <Form.Label className="text-2">{messagePage.active}</Form.Label>

                            <Form.Control
                                as="select"
                                className="text-2 border-radius-full"
                                type="text"
                                value={reportFilters.ativo || ''}
                                disabled={false}
                                onChange={event => setFilters(
                                    { ...reportFilters, ativo: event.target.value },
                                )}
                            >
                                {
                                    activeOptions.map(value => (
                                        <option key={value.message} value={value.id}>{value.message}</option>
                                    ))
                                }
                            </Form.Control>
                        </Form.Group>
                    </Row>
                </Form>
            </Container>

            <Container className="px-4 d-flex justify-content-end">
                <ButtonStandard
                    text={messages[lang].getReport}
                    textClass="text-1"
                    className="dropdown btn-outline-success btn-sm btn-standard px-2 mr-2"
                    disabled={isLoadingPreSchedulingReport}
                    dropdownActions={
                        [
                            {
                                label: 'CSV',
                                action: () => getCSVReport()
                            },
                            {
                                label: 'PDF',
                                action: () => getReport()
                            }
                        ]
                    }
                />

                {/* 
				<ButtonStandard
					text={messages[lang].getReport}
                    disabled={false}
					textClass="text-2"
					className="btn-sm btn-outline-success btn-standard px-2 mr-2"
					onClick={() => getReport()}/> */}
            </Container>

            {
                isLoadingPreSchedulingReport
                    ?
                    <div className="loader">
                        <LoadingSpinner />
                    </div>
                    :
                    null
            }

        </div>
    )
}

export default withRouter(PreSchedulingReport);